import { PhotoSubjectType } from '@common/interfaces/photo'
import ProfilePhoto from '../../../components/Common/ProfilePhoto'

interface IProps {
  /** Whose photo to show. Null/undefined renders the initials from `name` instead. */
  userId?: string | null
  /** Used for the alt text and to derive the initials shown when there's no photo. */
  name?: string | null
  className?: string
}

/**
 * A person's avatar in messaging.
 *
 * Now a thin adapter over Common/ProfilePhoto, which absorbed the fetch-by-id-and-cache behavior
 * this component pioneered and generalized it to every photo subject. Kept as its own name
 * because ~9 messaging call sites pass this prop shape.
 *
 * Two behavior changes come with the move: initials are now two letters and colored from the
 * shared palette (this rendered a single letter on MUI's default grey), and the cache is shared
 * with the rest of the app — so a photo already fetched for a CRM row costs nothing here.
 */
const MemberAvatar = ({ userId, name, className }: IProps) => (
  <ProfilePhoto
    name={name}
    subjectType={userId ? PhotoSubjectType.Users : undefined}
    id={userId}
    size="large"
    className={className}
  />
)

export default MemberAvatar
